export default {
  changePassword: {
    title: 'Change password',
    changePasswordButton: 'Change the password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    repeatPassword: 'Repeat new password',
    passwordSaved: 'Password saved!',
    passwordSavedHint: 'You are well protected',
    signIn: 'Sign in to your account',
  },
  signIn: {
    forgotPassword: 'Forgot password?',
    password: 'Password',
    email: 'E-mail',
    captchaLabel: 'Enter the characters you see',
    signInButton: 'Sign in',
    signUpLink: '<0>Not registered yet?</0> <1>Sign up</1>',
    mobile: {
      email: 'Your email',
      captchaLabel: 'Digits from the image',
    },
  },
  emailConfirm: {
    title: 'E-mail verification',
    verificationCodeSubmitted:
      'The verification code has been sent to your corporate e-mail address',
    requestCodeTimeout: 'You can request the code again in',
    sendNewCode: 'Send a new code',
    requestAnotherCode: 'Request another code',
    expiredConfirm: 'The validation code has expired. Do you want a new code to be sent?',
  },
};
